module.exports = __webpack_public_path__ + "7f493ee46547ae8cc03b738ab7812931.pdf";